<!--
 * @Author: your name

 * @LastEditTime: 2022-11-10 13:40:43
 * @LastEditors: taoyan taoyan_work@163.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /大增长星妈会C端/xmh-front-content/src/views/Home.vue
-->
<template>
  <div>
    <div v-if="homeShow" class="home-page">
      <!-- 滑动模块 -->
      <div
        :style="{
          backgroundImage:
            `url(${require(`../assets/images/aiTalk/user-card${ !isLoginFlag || !isEditFlag || currentBabyInfo.tag_id == 1 ? '-no' : ''}-bg.png`)})`
        }"
        class="wrapScrolly"
      >
        <!-- 头部卡片背景 -->
        <div class="user-card-bg">
          <!-- 头部搜索 -->
          <userCardSearch
            :babyDays="babyDays"
            :babyInfo="babyInfo"
            :currentBabyInfo="currentBabyInfo"
            :editFlag="isEditFlag"
            :loginFlag="isLoginFlag"
            currentPath="xmhHome"
            @getSwitchBaby="getSwitchBaby"
            @goLogin="goLogin()"
            @goToAiTalk="goToAiTalk('搜索栏')"
          >
          </userCardSearch>
          <!-- 用户卡片 -->
          <userCard
            :UserInfo="UserInfo"
            :babyDays="babyDays"
            :babyInfo="babyInfo"
            :currentBabyInfo="currentBabyInfo"
            :editFlag="isEditFlag"
            :loginFlag="isLoginFlag"
            @getBabyTips="getBabyTips"
            @getSwitchBaby="getSwitchBaby"
            @babySwiperClick="babySwiperClick"
            @goEdit="goEdit()"
            @goLogin="goLogin()"
          ></userCard>
        </div>

        <!-- 工具卡片 -->
        <toolCard
          :UserInfo="UserInfo"
          :babyDays="babyDays"
          :babyTipsList="babyTipsList"
          :currentBabyInfo="currentBabyInfo"
          :editFlag="isEditFlag"
          :loginFlag="isLoginFlag"
          @goEdit="goEdit()"
          @goLogin="goLogin()"
        >
        </toolCard>
        <!-- banner -->
        <homeBanner ref="babyBanner" @homeBannerClick="homeBannerClick"></homeBanner>
        <!-- 添加推荐tab组件 -->
        <titleTab
          :babyCurrentNum="babyCurrentNum"
          :babyDays="babyDays"
          :editFlag="isEditFlag"
          :loginFlag="isLoginFlag"
          :tagId="currentBabyInfo.tag_id ? currentBabyInfo.tag_id : ''"
        ></titleTab>
        <!-- 热门好文 -->
        <hotOliver
          :babyCurrentNum="babyCurrentNum"
          :curMonth="curMonth"
          :loginFlag="isLoginFlag"
          :tagId="currentBabyInfo.tag_id ? currentBabyInfo.tag_id : ''"
          title="热门好文"
          url="/babyWikipedia?from=home"
          @goLogin="goLogin()"
        ></hotOliver>
        <!-- 信息流 -->
        <informationList
          ref="informationListRefs"
          :babyCurrentNum="babyCurrentNum"
          :loginFlag="isLoginFlag"
          :tagId="currentBabyInfo.tag_id ? currentBabyInfo.tag_id : ''"
          @doctorsClick="doctorsClick"
          @homeResourceClick="homeResourceClick"
        ></informationList>
      </div>
      <!-- 浮标 -->
      <!-- <pendant></pendant> -->
      <!-- 预约成功弹窗 -->
      <subscribeSuccessCard
        v-if="subscribeSuccessCardFlag"
        :data="subscribeSuccessCardData"
        @close="subscribeSuccessCardClose"
      ></subscribeSuccessCard>
      <!-- 未注册用户预约弹窗 -->
      <registerCard
        v-if="registerCardFlag"
        @close="registerCardClose"
      ></registerCard>
      <!-- 京城名医视频 -->
      <foodVedio
        ref="childVideo"
        :showVedio="showVideo"
        :videoDetail="doctorInfo"
        :videoId="doctorInfo.id"
        :isShowComment="isShowComment"
        getContainer="#HorizontalScreen"
        isHfindex="true"
        @hideVedio="hideVideoEvent"
        @isUserLogin="isUserLogin"
      />
      <!-- 京城名医注册提示 -->
      <loginTip
        :show="doctorCheckLogin"
        @cancleWay="doctorCancelWay"
        @confirmWay="doctorConfirmWay"
      ></loginTip>
      <!-- 星妈课堂&京城名医分享海报 -->
      <div class="canvasPoster" @touchmove.prevent @mousewheel.prevent>
        <div class="share_box">
          <img
            :src="posterSrc"
            alt=""
            class="share-image"
            @touchend="posterSaveEnd($event)"
            @touchstart="posterSaveStart($event)"
          />
          <canvasPoster
            :painting="painting"
            class="poster"
            @close="posterClose"
            @fail="posterFail"
            @success="posterSuccess"
          >
          </canvasPoster>
        </div>
      </div>
      <!-- 互动弹窗 -->
      <!-- <popup :answerObj="answerObj" :show="popupShow" @closePopup="closePopup"></popup> -->
    </div>
    <van-overlay :show="!homeShow">
      <div class="wrapper" @click.stop>
        <van-loading type="spinner" />
      </div>
    </van-overlay>
    <!-- 悬浮球 -->
    <floating-ball v-if="homeShow" @click="goToAiTalk('悬浮图标')">
      <img class="floating-ball-ai-icon" src="@/assets/images/aiTalk/floating-ball-ai-icon.png" alt="" />
    </floating-ball>
  </div>
</template>

<script>
import Vue from 'vue'
import {getBabyInfo, getFindStart, getUserInfoByOpenId} from '@/assets/js/commonGetInfo.js'
import Store from '@/store.js'
import userCard from '@/components/home/userCard/index.vue' // 用户卡片
import userCardSearch from '@/components/home/userCardSearch/index.vue' // 用户卡片
import toolCard from '@/components/home/toolCard/toolCard.vue' // 工具卡片
import informationList from '@/components/home/informationList/index.vue' // 工具卡片
import homeBanner from '@/components/home/homeBanner.vue' // banner
// import pendant from "@/components/home/pendant.vue"; // 首页挂件
import subscribeSuccessCard from '@/components/home/subscribeSuccessCard.vue' // 预约成功弹窗
import registerCard from '@/components/home/registerCard.vue' // 未注册用户预约弹窗
import foodVedio from '@/views/contents/bjfamousdoctor/component/video.vue' //京城名医视频播放
import loginTip from '@/views/contents/calendar/component/logintip' //注册提示组件
import canvasPoster from '@/components/poster/canvas-poster.vue' //星妈课堂&京城名医海报
import titleTab from '@/components/home/titleTab.vue' //添加推荐tab组件
import popup from '@/components/home/popup.vue' //互动弹窗
import hotOliver from '@/components/home/hotOliver.vue'
import { BuiedPointClick_Fn, xmhh5_homepage_view } from '@/assets/js/BuriedPointEvent'
import {
  getCookie,
  getHeadImgAndName,
  getmotherState,
  getUserInfo,
  globalGoLogin,
  is_weixin,
  setCookie,
  globalGologinEdit,
} from '@/assets/js/common.js'
import {drawPoster} from '@/components/poster/posterjs/painter.js'
import { Debounce } from "@/assets/js/common.js"
import floatingBall from '@/components/floatingBall/index'

export default {
  name: 'home',
  data() {
    return {
      overlayshow: true,
      answerObj: {
        // 回答结果 给出默认值方便计算比例
        foodFalseNum: 0, // 回答不能吃的默认人数
        foodTrueNum: 0, // 回答能吃的默认人数
      },
      popupShow: false, // 问答弹窗
      isLoginFlag: null, // 是否登录
      UserInfo: {}, // 用户信息
      isEditFlag: false, // 是否定制
      isSuckTop: true,
      babyInfo: [], // 宝宝信息
      babyCurrentNum: 0, // 宝宝胎次
      curMonth: 0,
      currentBabyInfo: {}, // 当前选择宝宝信息
      babyDays: {
        // 宝宝天数
        firsttime: null,
        firsttime_pre: null,
        secondtime: null,
        secondtime_pre: null,
      },
      registerCardFlag: false, // 未注册用户预约
      subscribeSuccessCardFlag: false, // 预约成功弹窗
      subscribeSuccessCardData: {}, // 预约成功弹窗显示文案
      isRecommendSwitch: null, // 智能推荐状态 1关闭 0开启
      isShowComment: false,
      babyTipsList: [],
      doctorInfo: {}, // 京城名医相关信息
      showVideo: false, // 是否播放京城名医
      doctorCheckLogin: false, // 京城名医注册弹窗提示显示
      posterSrc: '', // 海报图片地址
      painting: {}, // 海报数据
      babyState: null, // 宝宝状态
      homeShow: false,
      babyBirthDays: [],
      // isSwitchBaby: false, // 是否切换宝宝
    }
  },
  components: {
    userCard,
    userCardSearch,
    toolCard,
    homeBanner,
    informationList,
    // pendant,
    subscribeSuccessCard,
    registerCard,
    foodVedio,
    loginTip,
    canvasPoster,
    titleTab,
    popup,
    hotOliver,
    floatingBall
  },
  async beforeRouteEnter(to, from, next) {
    let curVM = Vue.prototype
    console.log(1312)
    let getUserName = async function () {
      const { headImgurl, nickName } = await getHeadImgAndName()
      setCookie('xmh_headimgurl', headImgurl, 365)
      setCookie('xmh_nickname', nickName, 365)
    }
    Store.commit('changeIncludes', ['home'])
    if (is_weixin()) {
      // 微信环境
      if (getCookie('xmh_openid') == null || getCookie('xmh_openid') == '') {
        //判断有没有openId
        location.href =
          '/xmh/v2/wechat/oauth2/authorize?url=' +
          encodeURIComponent(window.location.href)
      } else {
        let UserInfo = JSON.parse(localStorage.getItem('userInfo'))
        if (
          UserInfo == null ||
          UserInfo == '' ||
          UserInfo.mobile == null ||
          UserInfo.mobile == '' ||
          UserInfo.mobile == 'null'
        ) {
          // 没有用户信息
          console.log('微信环境下的未登录')
          curVM.wxJsSet.getUserInfoBywx(
            curVM,
            async function () {
              // 重新获取用户信息
              let UserInfo = JSON.parse(localStorage.getItem('userInfo'))
              if (
                UserInfo &&
                UserInfo.mobile != null &&
                UserInfo.mobile != '' &&
                UserInfo.mobile != 'null'
              ) {
                await getUserName()
                await getBabyInfo()
                // await getFindStart(UserInfo.crm_id)
                console.log('微信环境下的登录')
                next((vm) => {
                  vm.isLoginFlag = true
                  vm.homeShow = true
                })
              } else {
                // 没有注册
                console.log('微信环境下的未登录2')
                sensors.login(getCookie('xmh_unionid'))
                // getFindStart('')
                next((vm) => {
                  vm.isLoginFlag = false
                  vm.isEditFlag = false
                  vm.homeShow = true
                })
              }
            },
            function () {
              console.log('微信环境下的未登录3')
              // getFindStart('')
              sensors.login(getCookie('xmh_unionid'))
              next((vm) => {
                vm.isLoginFlag = false
                vm.isEditFlag = false
                vm.homeShow = true
              })
            }
          )
        } else {
          // 有用户信息
          getUserName()
          await getBabyInfo()
          // getFindStart(UserInfo.crm_id)
          sensors.login(UserInfo.crm_id)
          console.log('微信环境下的登录2')
          next((vm) => {
            vm.isLoginFlag = true
            vm.homeShow = true
          })
        }
      }
    } else {
      // 非微信环境
      if (getCookie('xmh_phone') == null || getCookie('xmh_phone') == '') {
        console.log('【非微信环境】未登录')
        // getFindStart('')
        next((vm) => {
          vm.isLoginFlag = false
          vm.isEditFlag = false
          vm.homeShow = true
        })
      } else {
        let UserInfo = JSON.parse(localStorage.getItem('userInfo'))
        if (
          UserInfo &&
          UserInfo.mobile != null &&
          UserInfo.mobile != '' &&
          UserInfo.mobile != 'null'
        ) {
          getUserName()
          console.log('【非微信环境】登录')
          getBabyInfo()
          // getFindStart(UserInfo.crm_id)
          next((vm) => {
            vm.isLoginFlag = true
            vm.homeShow = true
          })
        } else {
          console.log('【非微信环境】未登录2')
          // getFindStart('')
          next((vm) => {
            vm.isLoginFlag = false
            vm.isEditFlag = false
            vm.homeShow = true
          })
        }
      }
    }
  },
  beforeDestroy() {},
  created() {
    sessionStorage.removeItem('feedTag')
    // this.init()
  },
  async mounted() {
    await getUserInfoByOpenId()
    this.UserInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    //智能推算，用户每次登录页面记录一次
    localStorage.setItem('intellectInfo', 'intellectInfo is true')

    this.init()
    this.overlayshow = false
    // document.cookie = "xmh_openid=oc63ewrB2j1BZ_Aa8MxU1wleB3Bg"
    console.log(this.$route.query.utm_campaign, 'this.$route.query.source')
    this.shareHome()
    if (this.$route.query.utm_campaign == 'XMH_H5_GZH_MANU') {
      // 点星妈宝典进入星妈会H5首页时触发
      this.$nextTick(() => {
        xmhh5_homepage_view.observe(
          'xmhh5_homepage_view',
          '.home-page',
          false,
          { xmhh5_homepage_view_channerl: '星妈宝典' }
        )
      })
    }
  },
  methods: {
    drawPoster,
    getUserInfo,
    homeBannerClick(value){
      this.showVideo = true
      this.isShowComment = true
      this.doctorInfo = value
      console.log(2312313123)
    },
    init() {
      this.handlerInfo() // 根据获取到的babyinfo初始化数据
      this.isRecommendSwitch = sessionStorage.getItem('isRecommendSwitch') // 获取是否开启了个性化推荐
      console.log('智能推荐状态', this.isRecommendSwitch)
    },

    // 跳转登录
    goLogin() {
      var that = this
      setTimeout(function () {
        // that.$router.push({
        //   path: "/phoneLogin?redirect=" + window.location.href
        // })
        globalGoLogin()
      }, 200)
    },
    // 跳转定制
    goEdit() {
      globalGologinEdit({ from: 'home' })
      // var that = this;
      // setTimeout(function () {
      //   // that.$router.push({
      //   //   path: "/loginEdit?redirect=" + window.location.href
      //   // })
      //   location.href =
      //     location.origin +
      //     "/member/loginEdit?redirect=" +
      //     window.location.href +
      //     "&title=" +
      //     that.$route.meta.title;
      // }, 200);
    },
    // 获取置顶弹窗状态
    getSuckTop(val) {
      this.isSuckTop = val
    },
    // 判断宝宝状态
    handlerInfo() {
      console.log(this.isLoginFlag, 'isLoginFlag')
      // 未登录，直接return；
      if (!this.isLoginFlag) return
      this.babyInfo =
        localStorage.getItem('babyInfo') &&
        JSON.parse(localStorage.getItem('babyInfo'))
      if (this.babyInfo && this.babyInfo.length > 0) {
        var babynumBir1 = ''
        var babyNum1 = ''
        var babynumBir2 = ''
        var babyNum2 = ''
        // 循环拿到每胎的生日
        for (var i = 0; i < this.babyInfo.length; i++) {
          if (this.babyInfo[i].num == '1') {
            babynumBir1 = this.babyInfo[i].birth
            babyNum1 = this.babyInfo[i].num
          } else if (this.babyInfo[i].num == '2') {
            babynumBir2 = this.babyInfo[i].birth
            babyNum2 = this.babyInfo[i].num
          }
        }
        // 判断第几胎月龄最小
        if (this.getCookie('babyNum')) {
          this.babyCurrentNum = this.getCookie('babyNum') // 从cookie中获取切换宝宝的胎次
          this.babyCurrentNum = parseInt(this.babyCurrentNum)
        } else {
          if (
            new Date(babynumBir1).getTime() &&
            new Date(babynumBir2).getTime()
          ) {
            // 判断两胎是否都有生日
            // 判断第几胎月龄小
            new Date(babynumBir1).getTime() < new Date(babynumBir2).getTime()
              ? (this.babyCurrentNum = 2)
              : (this.babyCurrentNum = 1)
          } else {
            babynumBir1 && !babynumBir2
              ? (this.babyCurrentNum = 1)
              : babynumBir2
              ? (this.babyCurrentNum = 2)
              : (this.babyCurrentNum = 1)
          }
          this.setCookie('babyNum', this.babyCurrentNum, 30)
          localStorage.setItem('babyNums', this.babyCurrentNum)
        }
        this.isEditFlag = true
        // cookie中存储的是胎次，babyInfo的下标和胎次不是对应的
        const babyCurrentNum = this.babyCurrentNum
        console.log(this.babyInfo)
        const currentBabyInfo = this.babyInfo.filter((item) => {
          return item.num == babyCurrentNum
        })
        this.currentBabyInfo = currentBabyInfo[0]
        // this.babyCurrentNum == 1 ? this.currentBabyInfo = this.babyInfo[0] : this.currentBabyInfo = this.babyInfo[1]
        this.getBabyState()
        this.getBabyDay(babynumBir1, babynumBir2)
      } else {
        localStorage.setItem('babyNum', 0)
        this.isEditFlag = false
      }
    },
    // 获取宝宝日期
    getBabyDay(bir1, bir2) {
      this.$http.post(
        '/parentingTips/getTimeWithBirth',
        {},
        { first: bir1, second: bir2 },
        (res) => {
          if (res.code == '200') {
            this.babyDays.firsttime = res.data.firsttime
            this.babyDays.firsttime_pre = res.data.firsttime_pre
            this.babyDays.secondtime = res.data.secondtime
            this.babyDays.secondtime_pre = res.data.secondtime_pre
            if (Object.keys(res.data).length > 0) {
              localStorage.setItem('babyTimes', JSON.stringify(this.babyDays))
            }
          }
        }
      )
    },
    // 星妈课堂-点击预约
    subscribeClick(data) {
      if (this.isLoginFlag) {
        this.subscribeSuccessCardFlag = true
        this.subscribeSuccessCardData = data
      } else {
        this.registerCardFlag = true
      }
    },
    // 星妈课堂-预约成功弹窗关闭
    subscribeSuccessCardClose() {
      this.subscribeSuccessCardFlag = false
    },
    // 引导注册弹窗关闭
    registerCardClose() {
      this.registerCardFlag = false
    },
    // 切换宝宝
    getSwitchBaby(data) {
      if (this.getCookie('babyNum') != this.currentBabyInfo.num) {
        this.babyCurrentNum = this.getCookie('babyNum')
        this.babyCurrentNum = parseInt(this.babyCurrentNum)
        for (var i = 0; i < this.babyInfo.length; i++) {
          if (this.babyCurrentNum == this.babyInfo[i].num) {
            this.currentBabyInfo = this.babyInfo[i]
            this.getBabyState()
            this.$refs.babyBanner && this.$refs.babyBanner.getBannerList()
          }
        }
        // 添加this.$nextTick是由于切换宝宝时，需要等tagId更新之后再去调用组件内的方法获取数据
        this.$nextTick(() => {
          // 获取首页信息流数据
          this.$refs.informationListRefs.getArticleList(true)
        })

        // this.isSwitchBaby = true
      }
    },
    // 宝宝下文字点击是视频类型
    babySwiperClick(value){
      this.showVideo = true
      this.isShowComment = true
      this.doctorInfo = value
    },
    // 获取智能推荐状态
    // getFindStart(crmId) {
    //   if (crmId != '') {
    //     this.$http.get('/smartSwitch/findStart', { crmId }, (res) => {
    //       if (res.code == 200) {
    //         sessionStorage.setItem('isRecommendSwitch', res.data.start)
    //         this.isRecommendSwitch = res.data.start
    //       }
    //     })
    //   } else {
    //     this.isRecommendSwitch = '1'
    //   }
    // },
    // 获取育儿贴士
    getBabyTips(item) {
      this.babyTipsList = item
    },
    // 京城名医点击
    doctorsClick(id) {
      const { code } = getmotherState()
      try {
        this.$http.post(
          '/capital/details',
          {},
          { id: id, crmId: this.getUserInfo(), memberLevelCode: code },
          (res) => {
            if (res.code == 200) {
              this.showVideo = true
              this.isShowComment = false
              this.doctorInfo = res.data
              this.shareHome()
              document.title = '京城名医'
            }
          },
          null,
          'lucky'
        )
      } catch {
        this.shareHome()
      }
    },
    // 首页点击资源位是视频
    homeResourceClick(value){
      console.log(value, 'homeResourceClick')
      if(value.jumpType === 3){

      }else if(value.jumpType === 5){
        this.isShowComment = true
        this.showVideo = true
        this.doctorInfo = {
          ...value,
          contentUrl: value.jumpTargetUrl,
          contentPayUrl: value.jumpTargetUrl,
        }
      }
    },
    // 首页分享初始化
    shareHome() {
      const shareDataParams = {
        shareLink: location.href.split('#')[0],
        shareDesc: '5000万中国妈妈信赖的育儿平台',
        shareTitle: '星妈会',
        imgUrl: 'https://image-mom.feihe.com/wxshare/home.png', //必须是绝对路径
      }
      this.wxJsSet.wxShare('fx', shareDataParams, this)
    },
    // 京城名医是否登录
    isUserLogin() {
      if (!this.isLoginFlag) {
        this.$refs.childVideo.Player.pause()
        this.doctorCheckLogin = true
      }
    },
    // 视频播放返回按钮
    hideVideoEvent() {
      document.title = '星妈会首页'
      this.showVideo = false
      // this.isShowComment = false
    },
    // 京城名医注册弹窗确认
    doctorConfirmWay() {
      this.doctorCheckLogin = false
      this.$refs.childVideo.isLogin()
      // this.loginRegistSensors("确定");
    },
    // 京城名医注册弹窗取消
    doctorCancelWay() {
      this.$refs.childVideo.Player.pause()
      this.$refs.childVideo.Player.currentTime = 9
      this.doctorCheckLogin = false
      // this.loginRegistSensors("取消");
    },
    // 星妈课堂-海报保存
    posterSuccess(src) {
      this.posterSrc = src
    },
    posterFail(err) {
      console.log('fail', err)
    },
    // 海报关闭
    posterClose() {
      this.posterSrc = ''
    },
    // 海报
    posterSaveStart: function (e) {
      e.stopPropagation()
      clearTimeout(this.posterTime)
      this.posterTime = setTimeout(function () {}, 500) //这里设置长按响应时间
    },
    posterSaveEnd: function (e) {
      e.stopPropagation()
      clearTimeout(this.posterTime)
    },
    // 获取宝宝状态
    getBabyState() {
      const { tag_id, sex } = this.currentBabyInfo
      if (tag_id) {
        let babyState
        switch (tag_id) {
          case '1':
            babyState = '备孕'
            break
          case '2':
            babyState = '怀孕'
            break
          default:
            sex == 'F' ? (babyState = '小公主') : (babyState = '小王子')
        }
        this.babyState = babyState
      } else {
        this.babyState = ''
      }
    },

    // 获取时间转成整数
    conversionTime(time) {
      // let dateClose = new Date();
      let dateClose = time
      let seperator1Close = '-'
      let yearClose = dateClose.getFullYear()
      let monthClose = dateClose.getMonth() + 1
      let strDateClose = dateClose.getDate()
      if (monthClose >= 1 && monthClose <= 9) {
        monthClose = '0' + monthClose
      }
      if (strDateClose >= 0 && strDateClose <= 9) {
        strDateClose = '0' + strDateClose
      }
      let currentdateClose = Number(
        (
          yearClose +
          seperator1Close +
          monthClose +
          seperator1Close +
          strDateClose
        ).replace(/-/g, '')
      )
      // console.log(currentdateClose,'currentdateClose');
      return currentdateClose
    },
    // 跳转AI对话页面
    goToAiTalk: Debounce(function(str) {
      if (!this.isLoginFlag) {
        // 未登录
        location.href = `${location.origin}/member/phoneLogin?isRegisterBack=true&redirect=${encodeURIComponent(`${location.origin}/aiTalk`)}`
      } else {
        // 已登录
        location.href = location.origin + "/aiTalk"
      }
      BuiedPointClick_Fn('feihebot_entry_click', {
        feihebot_entry_name: str
      })
    }),
    is_weixin,
    getCookie,
    setCookie,
  },
}
</script>

<style lang="less" scoped>
.home-page {
  background: linear-gradient(360deg, #f8f1fb 0%, #fff9fc 78%, #ffffff 100%);
  backdrop-filter: blur(10.00000028049245px);
}

.wrapScrolly {
  background-size: 100% auto;
  background-repeat: no-repeat;
}

.canvasPoster {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1000;

  .share_box {
    width: 254px;
    height: 454.5px;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    margin: auto;

    .share-image {
      position: absolute;
      width: 254.5px;
      height: auto;
      z-index: 1000;
    }
  }
}

.van-overlay {
  background-color: rgba(255, 255, 255, 0.6);
}

/deep/ .wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100% - 60px);
}
.floating-ball-ai-icon {
  width: 60px;
  height: 60px;
}
</style>
